// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div[data-v-3e8496d3]{margin:auto}.unvergessen-search-field[data-v-3e8496d3]{margin-right:15px}", ""]);
// Exports
module.exports = exports;
